import styled, { css } from "styled-components";

export const Title = styled.h1`
  ${({ theme }) => css`
    font-family: ${theme.font.family};
    color: ${theme.colors.text_extra_light};
    font-size: 32px;
    line-height: 38px;
    font-weight: 700;

    span {
      color: ${theme.colors.primary};
    }
  `}
`;

export const Line = styled.div`
  ${({ theme }) => css`
    border: 1px solid ${theme.colors.text};
    width: 450px;
    margin-top: 25px;
    margin-bottom: 25px;
  `}
`;

export const SubTitle = styled.p`
  ${({ theme }) => css`
    font-family: ${theme.font.family};
    font-size: 18px;
    line-height: 27px;
    color: ${theme.colors.text_extra_light};
    text-align: center;
    margin-top: 25px;
    width: 450px;
  `}
`;
